import React, { FC } from 'react';

import { styled } from '../theme';
import CloseButton from './CloseButton';
import FlexRow from './FlexRow';
import H1 from './H1';
import { useModal } from './Modal';

const HeaderWrapper = styled(FlexRow)`
    border-bottom: none;
    text-align: center;
    font-size: 2.6rem;
    padding: 24px 24px 0;
    margin-bottom: -10px;
    justify-content: space-between;
    position: relative;
`;
const Title = styled(FlexRow)`
    margin: 0 auto;
`;

const StyledCloseButton = styled(CloseButton)`
    top: 24px;
    right: 24px;
`;

type Props = {
    children?: React.ReactNode;
    closeButton?: boolean;
    className?: string;
};
const ModalHeader: FC<Props> = ({ children, closeButton, className }) => {
    const { onHide } = useModal();
    return (
        <HeaderWrapper align="center" className={className}>
            <Title>
                <H1>{children}</H1>
            </Title>
            {closeButton && <StyledCloseButton onClick={onHide} />}
        </HeaderWrapper>
    );
};
export default ModalHeader;
